import { render, staticRenderFns } from "./addressComponent.vue?vue&type=template&id=7e61344d"
import script from "./addressComponent.vue?vue&type=script&lang=js"
export * from "./addressComponent.vue?vue&type=script&lang=js"
import style0 from "./addressComponent.vue?vue&type=style&index=0&id=7e61344d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInputComponent: require('/home/node/app/components/ui/inputComponent.vue').default,UiIconsChevron: require('/home/node/app/components/ui/icons/chevron.vue').default,UiButtonComponent: require('/home/node/app/components/ui/buttonComponent.vue').default,ControllerAddress: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/checkout/ControllerAddress.js').default})
